import "core-js/stable"
import "regenerator-runtime/runtime"
import React from 'react'
import PropTypes from "prop-types"
import MulchStepForm from "./Shared/MulchStepForm.js"

const propTypes = {
  projectTypes: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  socialNetworks: PropTypes.array.isRequired,
  operationSystems: PropTypes.array.isRequired,
  projectAdTypes: PropTypes.array.isRequired,
  sociaNetworkPostTypes: PropTypes.array.isRequired,
  prefectures: PropTypes.array.isRequired,
  typeUseId: PropTypes.number.isRequired,
  typeVisitId: PropTypes.number.isRequired,
  typeBuyId: PropTypes.number.isRequired,
  typeAppUseId: PropTypes.number.isRequired,
}

const Edit = (props) => {
  return (
    <div>
      <h1>プロジェクト編集 {props.project.title}</h1>
      <MulchStepForm
        project={props.project}
        projectTypes={props.projectTypes}
        categories={props.categories}
        socialNetworks={props.socialNetworks}
        operationSystems={props.operationSystems}
        projectAdTypes={props.projectAdTypes}
        sociaNetworkPostTypes={props.sociaNetworkPostTypes}
        prefectures={props.prefectures}
        typeUseId={props.typeUseId}
        typeVisitId={props.typeVisitId}
        typeBuyId={props.typeBuyId}
        typeAppUseId={props.typeAppUseId}
        parent_category_id={props.parent_category_id}
        steps={props.project.published_at ? [2] : [1, 2, 3, 4, 5, 6]}
        completeText={"更新"}
        formPath={`/sponsor/projects/${props.project.id}`}
        formMethod={`patch`}
      />
    </div>
  )
}

Edit.propTypes = propTypes

export default Edit
